<template>
  <swiper
    :slidesPerView="'auto'"
    :spaceBetween="10"
    :pagination="{
      clickable: true,
    }"
    @swiper="onSwiper"
    @slideChange="onSlideChange"
    class="filter"
    id="container"
  >
    <template v-for="(categoryItem, index) in categoryList" :key="index">
      <swiper-slide>
        <a :href="'#' + categoryItem">{{ categoryItem }}</a>
      </swiper-slide>
    </template>
  </swiper>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
export default {
  name: "categorySlider",
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    categoryList: Array,
  },
  setup() {
    const onSwiper = (swiper) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log("slide change");
    };
    return {
      onSwiper,
      onSlideChange,
    };
  },
};
</script>

<style lang="css" scoped>
@import url(@/assets/style/components/categorySlider/categorySlider.css);
</style>